/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateTransactionRequest} from '@cash-web/protos/squareup/banklin/ledger_service.pb'
import {CreateTransactionResponse} from '@cash-web/protos/squareup/banklin/ledger_service.pb'


export const createTransaction = (request: CreateTransactionRequest, options?: CashRequestOptions) => post<CreateTransactionRequest, CreateTransactionResponse>("/2.0/cash/create-transaction", request, {...options, rejectOnError: true })